import { Theme } from '../../theme';

export const getScrollbarCss = (theme: Theme) => {
  return `
    ::-webkit-scrollbar {
      width: 10px;
      padding-left: 3px;
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 10px;
      border-left: solid 2px ${theme.header.backgroundDarker};
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
    }

    ::-webkit-scrollbar-track {
      background: none;
    }
  `;
};
